// extracted by mini-css-extract-plugin
export default {"header":"hMP61HUJMd7Cg4ZfkZp_","titleCell":"z0UfDx5Mt_NbUhhjLXtl"};